import { h } from "preact";
import { IColumnData } from "../interfaces/table";

export const COULMN_DATA = (props?: any): IColumnData[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "error",
    dataIndex: "error",
    key: "error",
    width: "10em",
    align: "left",
    render: (text, record) => {
      return <span style={{ color: 'red' }}>{text}</span>
    }
  },
  {
    title: "Model Number",
    dataIndex: "ModelNumber",
    key: "ModelNumber",
    width: "16em",
    align: "left",
  },
  {
    title: "Model Name",
    dataIndex: "ModelName",
    key: "ModelName",
    width: "16em",
    align: "left",
  },
  {
    title: "Model",
    dataIndex: "Model",
    key: "Model",
    width: "16em",
    align: "left",
  },
  {
    title: "Classification",
    dataIndex: "Classification",
    key: "Classification",
    width: "16em",
    align: "left",
  },
  {
    title: "Brand",
    dataIndex: "Brand",
    key: "Brand",
    width: "16em",
    align: "left",
  },
  {
    title: "Prod Type",
    dataIndex: "ProdType",
    key: "ProdType",
    width: "12em",
    align: "left",
  },
  {
    title: "Type",
    dataIndex: "Type",
    key: "Type",
    width: "12em",
    align: "left",
  },
  {
    title: "Type2",
    dataIndex: "Type2",
    key: "Type2",
    width: "12em",
    align: "left",
  },
  {
    title: "Sub Brand",
    dataIndex: "SubBrand",
    key: "SubBrand",
    width: "12em",
    align: "left",
  },
  {
    title: "Brand Type",
    dataIndex: "BrandType",
    key: "BrandType",
    width: "12em",
    align: "left",
  },
  
];
